/**
 * PaymentQrRenderer — the contract and the code's appearance, shared by both variants.
 *
 * The bodies genuinely diverge: web has no QR renderer, so it rasterises with `qrcode` into a
 * data URL inside an effect, while native draws vectors with react-native-qrcode-svg. What must
 * NOT diverge is the code itself — size, error-correction level and the two colours decide
 * whether a scanner reads it, so they live here once (rule 4: a split folder always has a
 * shared.ts).
 */
export interface QRCodeProps {
  url: string;
  size?: number;
}

/** Default edge length in px. Both platforms render the same square. */
export const QR_DEFAULT_SIZE = 260;

/** Recovers ~15% of a damaged/dirty code — enough for a screen, cheap in modules. */
export const QR_ERROR_CORRECTION_LEVEL = "M" as const;

export const QR_DARK_COLOR = "#000000";
export const QR_LIGHT_COLOR = "#FFFFFF";
